TrelloModel = require 'models/internal/trello-model'

module.exports = class CustomFieldOption extends TrelloModel
  typeName: 'CustomFieldOption'
  urlRoot: ->
    customField = @getCustomField()
    "/1/customField/#{ customField.id }/options"

  getCustomField: ->
    @collection.sourceModel

  move: (index) ->
    @update('pos', @getCustomField().calcPos(index, @))
    @collection.sort({ silent: false })
    return



// WEBPACK FOOTER //
// ./app/scripts/models/custom-field-option.coffee